import { AnimatedContainer, Box, ContentContainer } from 'components';
import React from 'react';

const NotFoundPage = () => {
  return (
    <AnimatedContainer>
      <ContentContainer>
        <Box>Page Not Found</Box>
      </ContentContainer>
    </AnimatedContainer>
  );
};

export default NotFoundPage;
